import { render, staticRenderFns } from "./Foto.vue?vue&type=template&id=19756319&scoped=true"
import script from "./Foto.vue?vue&type=script&lang=js"
export * from "./Foto.vue?vue&type=script&lang=js"
import style0 from "./Foto.vue?vue&type=style&index=0&id=19756319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19756319",
  null
  
)

export default component.exports